import CreateEmailTemplate from './CreateEmailTemplate';

export default CreateEmailTemplate;
